/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, {useState, useEffect} from "react";
import { LandingPage } from "../../../widgets/landing-page-widget";
import { CustomMetaTags } from "../../../widgets/custom-meta-titles";
import { useTheme } from "../../../providers/theme";
import { useSMLandingPage } from "../machines/pageContent";
import { VApplication } from "../../../application";
import { LandingPageService } from "../../../services";

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    "services.LandingPageService"
  ) as LandingPageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [buttonItem, setButtonItem] = useState();
  const srv = getSrv();

  useEffect(() => {
    async function getNavItems() {
      let _navlinks = await srv?.getHeaderNavItems();
      console.log(`nav items`, _navlinks);
      if (_navlinks) {
        setButtonItem(_navlinks);
      }
    }
    setTimeout(() => {
      getNavItems();
    }, 500);
  }, []);
  const { landingPageMachine, landingPageState, landingPageSend } =
    useSMLandingPage({});

  const _renderPage = () => {
    if (landingPageState?.matches("RENDER_PAGE")) {
      return (
        <>
          <CustomMetaTags
            {...(landingPageState?.event?.data?.value?.metaData || {})}
          />
          <LandingPage {...(landingPageState?.event?.data?.value || {})} 
          buttonItem={buttonItem}
          />
        </>
      );
    }
    if (landingPageState?.matches("GET_PAGE_CONTENT")) {
      return <div>Loading...</div>;
    }
    return null;
  };
  return <>{_renderPage()}</>;
};
